import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NzSelectItemInterface } from 'ng-zorro-antd/select';

@Component({
    selector: 'search-option-list',
    templateUrl: './search-option-list.component.html',
    styleUrl: './search-option-list.component.scss',
    standalone: false
})
export class SearchOptionListComponent {

    @Input() selectFormControl:FormControl;
    @Input() label:string;
    @Input() placeholder:string;
    @Input() options:object[] = [];
    @Input() filterCols:string[];
    @Input() valueField:string;
    @Input() displayFields:string[];
    @Output() onChangeData: EventEmitter<any> = new EventEmitter();

    selected = false;

    // o valor das opções é o objeto inteiro; a igualdade é pelo valueField
    compareWith = (a: any, b: any): boolean =>
      a && b && a[this.valueField] === b[this.valueField];

    // busca do nz-select sobre as colunas configuradas (não sobre o label exibido)
    filterOption = (input: string, option: NzSelectItemInterface): boolean => {
      const search = (input || '').toLowerCase();
      const item = option.nzValue;
      const cols = this.filterCols?.length ? this.filterCols : this.displayFields;
      return (cols || []).some(col =>
        (item?.[col] ?? '').toString().toLowerCase().indexOf(search) > -1
      );
    };

    onChange(value: any) {
      this.selected = true;
      this.onChangeData.emit(value);
    }

    getDisplay(item:object):string {
      let display = '';
      this.displayFields.forEach(field => {
          if ( display == '' ){
            display += item[field]  ;
          }else{
            display += ' - ' + item[field];
          }
      });
      return display;
    }
}
